<script setup lang="ts">
import { useNotificationStore } from '@/stores/notifications'
import ToastItem from './ToastItem.vue'

const notifications = useNotificationStore()
</script>

<template>
  <Teleport to="body">
    <div class="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 items-end">
      <TransitionGroup name="toast" tag="div" class="flex flex-col gap-2 items-end">
        <ToastItem v-for="toast in notifications.toasts" :key="toast.id" :toast="toast" />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-enter-active { transition: all 0.2s ease; }
.toast-leave-active { transition: all 0.2s ease; }
.toast-enter-from  { opacity: 0; transform: translateX(1rem); }
.toast-leave-to    { opacity: 0; transform: translateX(1rem); }
</style>
